export function setupDisplay(){
 const button=document.querySelector('#fullscreen') as HTMLButtonElement;
 const help=document.querySelector('#install') as HTMLDialogElement;
 document.querySelector('#close-install')!.addEventListener('click',()=>help.close());
 button.addEventListener('click',async()=>{
  try{
   if(document.fullscreenElement){await document.exitFullscreen();return;}
   if(document.fullscreenEnabled&&document.documentElement.requestFullscreen){
    await document.documentElement.requestFullscreen();
   }else help.showModal();
  }catch{help.showModal();}
 });
 document.addEventListener('fullscreenchange',()=>{
  button.setAttribute('aria-label',document.fullscreenElement?'Выйти из полного экрана':'Полный экран');
  button.setAttribute('aria-pressed',String(Boolean(document.fullscreenElement)));
  window.dispatchEvent(new Event('resize'));
 });
 // Network-first, no application caching: future HTTPS support without stale builds.
 if(window.isSecureContext&&'serviceWorker'in navigator)
  navigator.serviceWorker.register(import.meta.env.BASE_URL+'sw.js').catch(console.warn);
}
